<template>
<div class="mt_140">

<ccMenu ref="cc_menu" v-bind:posicao=4></ccMenu>
<ccLoading v-show="loading" ref="cc_loading"></ccLoading>

  <div class="container">

    <!-- Filtro/Visualizar
    <div class="row mb-3">
        <div class="col-2">
          <div class="form-group">
            <select class="form-control form-control-sm" v-model="frm_torneio_tipo" @change="filtro_tipo(frm_torneio_tipo)">
              <option value=0>Todos</option>
              <option value=1>Um contra o outro</option>
              <option value=2>Preço fixo</option>
              <option value=3>Torneio grátis</option>
            </select>
          </div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <select class="form-control form-control-sm" v-model="frm_torneio_buy_in" @change="filtro_buy_in(frm_torneio_buy_in)">
              <option value="all">Valor de entrada</option>
              <option value="r1">0 - 5R$</option>
              <option value="r2">R$5 - R$30</option>
              <option value="r3">R$30 - R$100 </option>
              <option value="r4">R$100 - em diante  </option>
            </select>
          </div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <select class="form-control form-control-sm" v-model="frm_torneio_next" @change="filtro_next(frm_torneio_next)">
              <option value="all">Próximos torneios</option>
              <option value="1H">Começa em 1 horas</option>
              <option value="2H">Começa em 2 horas</option>
              <option value="3H">Começa em 3 horas</option>
              <option value="24H">Começa em 24 horas</option>
              <option value="+24H"> Maior que 24 horas</option>
            </select>
          </div>
        </div>
    </div>
    -->

    <!-- tags ----------------------------------------------------------------------->
    <section class="mb-4">
      <div style="overflow-x: auto; display: flex;">
        <div class="mb-2" style="flex: 0 0 auto;">
          <div class="tag" v-for="tag of tags">
            <button class="btn btn-sm" @click="filtro_tag(tag.tag_id)" v-bind:class="[tag.tag_id==tag_id ? 'btn-warning' : 'btn-outline-warning']">
              {{tag.tag_nome}}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- layout 1 ------------------------------------------------------------------>
    <section v-show="layout1">
        <div class="row p-0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;" v-show="this.original.length > 0">
            <div class="col-md-12 p-0">

                  <div class="mb-3">
                      <section id="torneio_free_destaque" class="p-4">

                        <!-- <ccCard ref="cc_card"></ccCard> -->

                          <div class="row" v-for="(tor, index) of torneio_agrupados" :key="index">
                            <div class="col-md-12">
                                <div class="card text_branco mb-3 card_turbo">
                                  <div class="row">

                                    <div class="col-7">
                                        <div class="text_15 text_branco mb-1"> <img :src="tor.jogos[0].pais_logo == null ? 'http://api.sokkerpro.net/assets/flags/99474.png' : tor.jogos[0].pais_logo" width="20px" alt="...">
                                          {{tor.jogos[0].liga}}
                                          <span class="text_13 text_vermelho_vivo text_bold" v-if="tor.jogos[0].status == 'LIVE' || tor.jogos[0].status == 'HT'">
                                            Ao vivo
                                          </span>
                                        </div>

                                        <div class="text_15 text_branco mb-1 text_bold" v-show="tor.jogos[0].status == 'LIVE' || tor.jogos[0].status == 'HT'">
                                          {{ tor.jogos[0].time1}}
                                          <img :src='tor.jogos[0].localteam_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="25px" v-show="tor.jogos[0].localteam_logo != null">
                                          <span class="text_vermelho_vivo">
                                          <b>{{tor.jogos[0].localteam_score}}</b>
                                          x
                                          <b>{{tor.jogos[0].visitorteam_score}}</b>
                                          </span>
                                          <img :src='tor.jogos[0].visitorteam_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="25px" v-show="tor.jogos[0].visitorteam_score != null">
                                          {{tor.jogos[0].time2}} &nbsp;
                                          <b class='text_vermelho_vivo'>{{tor.jogos[0].minute}}'</b>
                                        </div>

                                        <div class="text_15 text_branco mb-1 text_bold" v-show="tor.jogos[0].status != 'LIVE' && tor.jogos[0].status != 'HT'">
                                          {{ tor.jogos[0].time1.substring(0, 3).toUpperCase()}}
                                          <img :src='tor.jogos[0].localteam_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="25px" v-show="tor.jogos[0].localteam_logo != null">
                                          :
                                          <img :src='tor.jogos[0].visitorteam_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="25px" v-show="tor.jogos[0].visitorteam_logo != null">
                                          {{tor.jogos[0].time2.substring(0, 3).toUpperCase()}}
                                        </div>

                                        <div class="text_12 text_branco">
                                          <div class="text_15 mb-0" v-if="tor.mercado_escolhido >= 9 && tor.mercado_escolhido <= 16"> 
                                            VAI SAIR ESCANTEIO? 
                                            <img :src='"../../assets/image/bandeirinha.png"' width="16px">
                                          </div>
                                          <div class="text_15 mb-0" v-else> 
                                            VAI SAIR GOL? 
                                            <img :src='"../../assets/image/bola_branca.png"' width="20px">
                                          </div>

                                          <div class="text_14 text_bold text_branco mb-0"> {{nomeMercadoEscolhido(tor.mercado_escolhido)}} </div>
                                          <div class="text_14 text_cinza" v-if="tor.dif<=0"> {{cornerComecaMinuto(tor.mercado_escolhido)}} </div>
                                          <div class="text_13 text_cinza" v-if="tor.dif>0">Começa em: <span class="text_amarelo text_bold">{{tor.time_regressivo}}</span> </div>
                                        </div>

                                        <!-- <div class="text_13 text_branco mb-1 text_bold" v-show="tor.jogos[0].status != 'LIVE'">
                                          {{ tor.jogos[0].time1}}
                                          <img :src='tor.jogos[0].localteam_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="22px" v-show="tor.jogos[0].localteam_logo != null">
                                          x
                                          <img :src='tor.jogos[0].visitorteam_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="22px" v-show="tor.jogos[0].visitorteam_score != null">
                                          {{tor.jogos[0].time2}}
                                        </div>

                                        <div class="text_13 text_branco mb-1 text_vermelho text_bold" v-if="tor.jogos[0].status == 'LIVE'">{{tor.jogos[0].minute}}' </div>
                                        <div class="text_13 text_cinza" v-if="tor.dif<=0">Começou em: <span class="text_branco text_bold">{{timestamp_dataBR(tor.dt_inicio_timestamp,3)}}</span> </div>
                                        <div class="text_13 text_cinza" v-if="tor.dif>0">Começa em: <span class="text_amarelo text_bold">{{tor.time_regressivo}}</span> </div> -->
                                    </div>

                                    <div class="col-3 pe-3 pt-4">
                                      <div class="text_amarelo text_12 mb-2">
                                          <div class="form-group">
                                            <select class="form-control form-control-sm" v-model="selectTorneioId[index]">
                                              <option :value=0>Entrada: Escolha</option>
                                              <option v-for="item of tor.torneioCheckbox" :value="item.tor_id">Entrada: R$ {{item.taxa}}</option>
                                            </select>
                                          </div>
                                      </div>
                                      <div class="text_13 text_branco text_bold text-end" v-if="selectTorneioId[index]">
                                        Ganha: R$ {{getCaracteristicasTorneio(selectTorneioId[index]).prize}} para o 1°
                                      </div>
                                    </div>

                                    <div class="col-2 pt-4" style="border-left: solid 1px #171a26;">
                                      <div class="row mb-2">
                                        <div class="col-12">
                                          <button class="btn btn-sm btn-outline-success w-100 text_15" @click="perguntar_modal_mensagem(index,'sim')"> SIM </button>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-12">
                                          <button class="btn btn-sm btn-outline-success w-100 text_15" @click="perguntar_modal_mensagem(index,'nao')"> NÃO </button>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                            </div>
                          </div>

                      </section>
                  </div>

            </div>
        </div>
    </section>
    <!-- layout 1: fim ------------------------------------------------------------->

    <!--TELA DE NENHUM TORNEIO-->
    <section class="p-4" v-show="this.original.length == 0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;">
        <div class="col-12 mb-2">
            <div class="text-center text_branco text_15 mb-3">
              <br><br>
              Não existe nenhum torneio ativo no momento <br>
              Use o filtro acima para ver mais torneios ou
                  <router-link to="/home/torneio/0"><b class="text_verde" style="text-decoration:none;">clique aqui</b></router-link>
              para ver torneios das próximas horas
              <br><br>
            </div>

        </div>
    </section>
    <!--TELA DE NENHUM TORNEIO: FIM-->

  <ccAlert ref="cc_alert"></ccAlert>

</div>

<ccMensagemTurbo ref="cc_mensagem_turbo" @evento_teste="resposta_modal_mensagem"></ccMensagemTurbo>

<ccFooter></ccFooter>
</div>
</template>

<script>

import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccFooter from '../layout/footer.vue'
import ccMensagemTurbo from '../cc_geral/mensagem_turbo.vue'
import ccAlert from '../cc_geral/cc_alert.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccCard from './turbo_cc_card.vue'
import Cookies from 'js-cookie'

export default {

  components: {ccMenu, ccFooter, ccMensagemTurbo, ccAlert, ccLoading, ccCard},

  data () {
    return {
      //socket
      socket : {},
      canal : "canal_home_torneio_turbo",
      countSocket: 0,
      fala_servidor: null,
      fonte: null,

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //array
      original: [],
      torneio: [],
      tags: [],
      torneio_agrupados: [],
      selectTorneioId: [],
      selectTorneioGanho: [],

      //filtro
      frm_torneio_tipo: 0,
      frm_torneio_buy_in: 'all',
      frm_torneio_next: 'all',
      timer_torneio_horario: null,
      timer_jogos_minutos: null,

      //layout
      layout1: true,

      //variaveis
      tag_id: 0,
      sim_nao: null,
      ganha: 0,
    }
  },

  created(){
    document.title = 'Torneios Turbo- SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    this.frm_torneio_tipo = this.$route.params.tipo_id
    this.tag_id = this.$route.params.tag_id
    this.escute_canal()
  },

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
    }else{
      this.user = a
    }

    this.get_all_torneio_abertos(1)
    this.start_time()
    this.start_time_jogos_minutos()
  },

  methods: {

      escute_canal(){
        this.socket = this.$store.state.socket;

        //quantos logados no socket
        this.socket.on('countSocket', (data) => {
          this.countSocket = data;
        });

        this.socket.on( this.canal, (data) => {
            this.fonte = data.fonte
            // this.original = data.resp.torneios;
            // this.higienizar()
            this.get_all_torneio_abertos(0)
        });
      },

      get_all_torneio_abertos(load){

        if(load != 0){
          this.loading = true;
        }

        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'home/torneio/turbo', header)
        .then(response => {
          this.fonte = response.data.fonte
          this.original = response.data.resp.torneios;
          this.tags = response.data.resp.tags;
          this.higienizar()
          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
      },

      higienizar()
      {
        let agora = Date.now()
        let a = this.original
        var obj = {}
        this.tor = []
        let dif = null;
        this.torneio = []
        let aux = []
        let aux2 = []

        //get primeiro do agrupamento de torneios com o mesmo valor de agrupado_com
        var torneiosAgrupados = [];
        for (var i=0; i <= a.length -1; i++)
        {
            var encontrado = torneiosAgrupados.some(objeto => objeto.agrupado_com === a[i].agrupado_com)
            if (encontrado == false){
              torneiosAgrupados.push(a[i]);
            }
        }
        this.torneio_agrupados = torneiosAgrupados

        //inserindo mais um campo e colocando os torneios pertencentes ao mesmo agrupamento
        for (var i=0; i <= this.torneio_agrupados.length -1; i++)
        {
          let torneios_por_taxa = [];
          for (var j=0; j <= this.original.length -1; j++)
          {
            // console.log( this.original[j].agrupado_com +' - '+ this.torneio_agrupados[i].id )

            if(this.original[j].agrupado_com == this.torneio_agrupados[i].id ){
              obj = { 'tor_id': this.original[j].id, 'taxa': this.original[j].taxa_entrada, };

              //so coloque se obj taxa nao contiver
              if (!torneios_por_taxa.some(objeto => objeto.taxa === obj.taxa)){
                torneios_por_taxa.push(obj);
              }

            }
          }
          this.torneio_agrupados[i].torneioCheckbox = torneios_por_taxa;
        }

        //coloque o select em cada um dos select dos torneios
        this.torneio_agrupados.forEach(tor => {

          //coloquei este script para garantir o select no primeiro item
          this.selectTorneioId.push(0);
          this.selectTorneioGanho.push(0);

          /*
          if (tor.torneioCheckbox.length > 0) {
              this.selectTorneioId.push(tor.torneioCheckbox[0].tor_id);
              this.selectTorneioGanho.push(tor.torneioCheckbox[0].taxa);
          } else {
              this.selectTorneioId.push(null); // ou algum valor padrão caso não haja itens
              this.selectTorneioGanho.push(null); // ou algum valor padrão caso não haja itens
          }
          */
        });

        this.torneio_agrupados = this.torneio_agrupados.map(item => {
          return {
            ...item,
            dif: parseInt(((item.dt_inicio_timestamp * 1000) - Date.now())/1000),
            time_regressivo: this.timestamp_horas_minutos_segundos( parseInt(((item.dt_inicio_timestamp * 1000) - Date.now())/1000)   ),
            // time_regressivo: dif,
          };
        });

        //filtro de tags
        if( this.tag_id > 0){
          aux = this.torneio_agrupados.filter((item) => item.tag_id == this.tag_id)
          this.torneio_agrupados = aux
        }

      },

      filtro_tipo(tipo){
        this.frm_torneio_tipo = tipo
        this.higienizar()
      },

      filtro_buy_in(buy_in){
        this.frm_torneio_buy_in = buy_in
        this.higienizar()
      },

      filtro_next(next){
        this.frm_torneio_next = next
        this.higienizar()
      },

      show_layout1(){
        this.layout1 = true
        this.layout2 = false
        Cookies.set('sokkerduel_layout_card', 1, { expires: 30 } )
      },

      show_layout2(){
        this.layout1 = false
        this.layout2 = true
        Cookies.set('sokkerduel_layout_card', 2, { expires: 30 } )
      },

      start_time(){
        this.timer_torneio_horario = setInterval( function() {

          for (var i=0; i < this.torneio_agrupados.length; i++) {
            this.torneio_agrupados[i].dif = this.torneio_agrupados[i].dif - 1
            this.torneio_agrupados[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio_agrupados[i].dif )
            // this.torneio_agrupados[i].time_regressivo = this.torneio_agrupados[i].dif
          }

        }.bind(this), 1000);
      },

      filtro_tag(tag_id){
        if(this.tag_id == tag_id){
          this.tag_id = 0
        }else{
          this.tag_id = tag_id
        }
        this.higienizar()
      },

      async perguntar_modal_mensagem(index, sim_nao)
      {
        this.torneio_id = this.selectTorneioId[index];
        this.selectTorneioGanho[index] = 0;
        this.ip = null;
        this.sim_nao = sim_nao
        let sim_nao_hidratado = this.sim_nao == 'sim' ? 'Sim' : 'Não'

        //trava
        if( this.torneio_id == 0){
          var obj = {
            cor: 2,
            torneio: 0,
            titulo: "SELECIONE UM VALOR DE ENTRADA",
            texto: null,
            btn1_ativo: false,
            btn1_cor: 1,
            btn1_texto: null,
            btn1_link: null,
            btn1_link_next: true,
            btn2_ativo: true,
            btn2_cor: 2,
            btn2_texto: 'Entendi',
            btn2_link: null,
            btn2_link_next: true,
          }
          this.$refs.cc_mensagem_turbo.receber_dados(obj);
          return
        }

        let torneio = this.getCaracteristicasTorneio(this.torneio_id)

        if(this.torneio.tipo_id == 3){
            await fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => {
                this.ip = data.ip
            })
            .catch(error => {
              this.ip = null;
              this.error = 'Erro ao obter endereço IP: ' + error.message;
            });
        }

        var body = {
          usuario_id: this.user.id,
          torneio_id: this.torneio_id,
          ip: this.ip
        };

        var header = {'headers': {'x-access-token': this.user.access_token, }};
        await axios.post(this.base_url_api+'aposta/turbo/autorizacao', body, header)
        .then(response => {

          let m = response.data

          // usuario_bloqueado
          // dinheiro_insuficiente
          // torneio_iniciado
          // max_reentrada_atingido
          // max_aposta_atingido
          // tempo_aposta_esgotado

          //tudo certo para apostar sem apostas vazias
          if(m.status == 'success' && m.resp.aposta_check_vazia_count == 0){
            var obj = {
              cor: 1,
              torneio: torneio,
              titulo: this.nomeMercadoEscolhido(torneio.mercado_escolhido)+':  '+sim_nao_hidratado,
              texto: 'Depois que entrar não poderá cancelar.',
              btn1_ativo: true,
              btn1_cor: 1,
              btn1_texto: 'SIM, ENTRAR',
              btn1_link: '#',
              btn1_link_next: false,
              btn2_ativo: true,
              btn2_cor: 2,
              btn2_texto: 'NÃO, SAIR',
              btn2_link: '#',
              btn2_link_next: false,
            }
            this.$refs.cc_mensagem_turbo.receber_dados(obj);
          }

          //tudo certo para apostar com apostas vazias
          if(m.status == 'success' && m.resp.aposta_check_vazia_count > 0){
            var obj = {
              cor: 1,
              torneio: torneio,
              titulo: this.nomeMercadoEscolhido(torneio.mercado_escolhido)+':  '+sim_nao_hidratado,
              texto: 'Depois que entrar não poderá cancelar.',
              btn1_ativo: true,
              btn1_cor: 1,
              btn1_texto: 'SIM, ENTRAR',
              btn1_link: '#',
              btn1_link_next: false,
              btn2_ativo: true,
              btn2_cor: 2,
              btn2_texto: 'NÃO, SAIR',
              btn2_link: '#',
              btn2_link_next: false,
            }
            this.$refs.cc_mensagem_turbo.receber_dados(obj);
          }

          if(
            m.resp.erro == 'usuario_bloqueado' || m.resp.erro == 'dinheiro_insuficiente' ||
            m.resp.erro == 'torneio_iniciado' ||
            m.resp.erro == 'max_aposta_atingido' || m.resp.erro == 'tempo_aposta_esgotado'
          ){
            var obj = {
              cor: 1,
              torneio: torneio,
              titulo: m.resp.erro,
              texto: null,
              btn1_ativo: false,
              btn1_cor: 1,
              btn1_texto: null,
              btn1_link: '#',
              btn1_link_next: true,
              btn2_ativo: true,
              btn2_cor: 2,
              btn2_texto: 'Voltar',
              btn2_link: null,
              btn2_link_next: true,
            }
            this.$refs.cc_mensagem_turbo.receber_dados(obj);
          }

        })
        .catch(e => {

          if(e.response.status == 400)
          {
            if(e.response.data.slug == 'max_reentrada_atingido'){
                var obj = {
                  cor: 2,
                  torneio: torneio,
                  titulo: e.response.data.msg,
                  texto: null,
                  btn1_ativo: true,
                  btn1_cor: 3,
                  btn1_texto: 'EDITAR APOSTA',
                  btn1_link: '/torneio/'+this.torneio_id,
                  btn1_link_next: true,
                  btn2_ativo: true,
                  btn2_cor: 2,
                  btn2_texto: 'VOLTAR',
                  btn2_link: null,
                  btn2_link_next: true,
                }
            }else{
                var obj = {
                    cor: 2,
                    torneio: torneio,
                    titulo: e.response.data.msg,
                    texto: null,
                    btn1_ativo: false,
                    btn1_cor: 1,
                    btn1_texto: null,
                    btn1_link: '#',
                    btn1_link_next: true,
                    btn2_ativo: true,
                    btn2_cor: 2,
                    btn2_texto: 'Voltar',
                    btn2_link: null,
                    btn2_link_next: true,
                }
            }

            this.$refs.cc_mensagem_turbo.receber_dados(obj);
            return
          }


          if(e.response.status == 401){
            var obj = {
                  cor: 1,
                  torneio: torneio,
                  titulo: 'Para apostar precisa está logado!',
                  texto: 'Faça o login!!',
                  btn1_ativo: true,
                  btn1_cor: 1,
                  btn1_texto: 'ACESSAR',
                  btn1_link: '/login',
                  btn1_link_next: true,
                  btn2_ativo: true,
                  btn2_cor: 2,
                  btn2_texto: 'CANCELAR',
                  btn2_link: '#',
                  btn2_link_next: false,
            }
            this.$refs.cc_mensagem_turbo.receber_dados(obj);
            return
          }

        });
      },

      resposta_modal_mensagem(variable){
        if(variable){
          this.montar_aposta_temporaria()
        }
      },

      montar_aposta_temporaria(){
        this.loading = true

        var body = {
          torneio_id: this.torneio_id,
          sim_nao: this.sim_nao
        }

        // console.log(this.torneio_id, this.sim_nao)
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.post(this.base_url_api+'aposta/turbo/save', body, header)
        .then(response => {

            const torId = response.data.original.tor_id;

            this.$router.push({ path: '/torneio/'+ torId });

            this.loading = false
        })
        .catch(e => {
            this.errors.push(e);
            // this.expluse_para_login()
        });
      },

      getCaracteristicasTorneio(tor_id){
        var a = this.original.find((tor) => tor.id == tor_id)

        if (a) {
          return a
        } else {
          console.error(`No item found with id ${tor_id}`)
          return null
        }
      },


      start_time_jogos_minutos(){
        this.timer_jogos_minutos = setInterval( function() {

          this.get_all_torneio_abertos(0)

        }.bind(this), 50000);
      },

  },

  destroyed(){
    this.socket.off('canal_home_torneio_turbo');
  }

}
</script>

<style scoped>
    .form-control {
        color: #ffffff80;
        background-color: #333644;
        border: none;
    }

    .tag{
      float: left;
      padding-right: 15px;
    }

    /* Largura da barra de rolagem */
    ::-webkit-scrollbar {
      width: 10px; /* largura */
      height: 5px; /* altura */
    }

    /* Cor da barra de rolagem */
    ::-webkit-scrollbar-track {
      background: #0A0D1A;
    }

    /* Cor do indicador da posição atual da barra de rolagem */
    ::-webkit-scrollbar-thumb {
      background: #686868;
    }

    /* Arredondar as bordas do indicador da barra de rolagem */
    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
    }

    select.form-control {
      background-image: url("../../assets/image/down-arrow.svg");
      background-size: 20px;
      background-position: right 10px top 5px;
      background-repeat: no-repeat;
      /* background: #36394580 0% 0% no-repeat padding-box; */
      border: 2px solid #3E3E3E80;
      /* background-color: #36394580; */
      border-radius: 5px;
      /* color: #FFFFFF4D; */
    }

    .btn-outline-success{
      background: #5ABB1014 0% 0% no-repeat padding-box;
      border: 1px solid #5ABB10BD;
      border-radius: 6px;
      text-shadow: 0px 1px 6px #5ABB10;
    }

    .btn-outline-danger{
      background: #E6570D12 0% 0% no-repeat padding-box;
      border: 1px solid #F01F1F;
      border-radius: 6px;
      text-shadow: 0px 1px 6px #F01F1F;
    }

</style>


// WEBPACK FOOTER //
// src/components/turbo/turbo.vue